import React from "react";
import { createBrowserRouter, createRoutesFromElements, Navigate, Outlet, Route } from "react-router-dom";
import ContentLayout from "@webcore/layouts/ContentLayout.tsx";
import Homepage from "@/components/Homepage.tsx";
import SolutionsSaas from "@/components/solutions/SolutionsSaas.tsx";
import SolutionsEcommerce from "@/components/solutions/SolutionsEcommerce.tsx";
import Blog from "@/components/Blog.tsx";
import BookADemo from "@/components/BookADemo.tsx";
import Privacy from "@webcore/components/domain/content-site/pages/Privacy.tsx";
import TermsOfService from "@webcore/components/domain/content-site/pages/TermsOfService.tsx";
import TelemetryProvider from "@webcore/context-providers/TelemetryProvider.tsx";
import { contentNavLinks } from "@/routes/contentNavLinks.ts";

function ContentMain() {
  return (
    <TelemetryProvider>
      <Outlet />
    </TelemetryProvider>
  );
}

// Blog post detail pages (/blog/<slug>) are intentionally not a route here — they're prerendered
// to static HTML at build time (see scripts/prerender-blog-posts.tsx) and served directly by
// Front Door, bypassing this SPA entirely. To preview a post locally, run `npm run build:dev`
// (or `build`) then `npm run preview` — that's the same pipeline real deployments use.

const contentBrowserRouter = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<ContentMain />}>
      <Route
        path=""
        element={
          <ContentLayout
            navLinks={contentNavLinks}
            showSignInButtons={true}
            signUpEnabled={true}
          />
        }
      >
        <Route path="" element={<Homepage />} />
        <Route path="solutions/saas" element={<SolutionsSaas />} />
        <Route path="solutions/ecommerce" element={<SolutionsEcommerce />} />
        <Route path="blog" element={<Blog />} />
        <Route path="book-a-demo" element={<BookADemo />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="terms-of-service" element={<TermsOfService />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Route>
    </Route>,
  ),
);

export default contentBrowserRouter;
